module.exports = __webpack_public_path__ + "static/media/icon-piece3-5.41026787.png";